<div class="mainBoardMainDiv">
    <app-header></app-header>
    <div class="mainBoardBody">
        <app-sidebar></app-sidebar>
        <div class="appDynamicScreen">
            <div class="screenBodyContent">
                <router-outlet (activate)="commonService.changeOfRoutes()"></router-outlet>
            </div>
            <!-- <app-footer></app-footer> -->
        </div>

    </div>
</div>